export default function mediaText() {
  // $('.wp-block-media-text').each(function () {
  //   /**
  //    * Retina image sizes
  //    */
  //   $(this)
  //     .find('.wp-block-media-text__media img')
  //     .each(function () {
  //       $(this).css('width', `${$(this).attr('width') / 2}px`);
  //     });
  // });
}
